/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import Typography from "@mui/material/Typography";

const PermitListAuthDisplay = (props) => {

    const { text } = props;
    
    return (
        <div className='permit-list-auth-display'>
            <Typography variant='body1' color={"text.primary"}>
                {text}
            </Typography>
        </div>
    );
};

PermitListAuthDisplay.displayName = "PermitListAuthDisplay";
export { PermitListAuthDisplay };
